export default __webpack_public_path__ + "img/172217c668eebce7c0fe480d1f54c366.png";